import { makeAutoObservable, spy } from "mobx"

export default class DeliveryStore {
	editDataPickup
	editDataDelivery
	basketStore
	dliveryStore = null
	allMethods = []
	active = null
	previousActive = null
	primeDelivery = null
	error = null
	hasError = false
	price = 0
	terms = null
	officePvz = null
	cityInfo = null
	express = false
	fitting = false
	cityInfoError = ''
	selectedAddress = ''
	searchAddress = ''
	myAddresses = []
	customerInfo = {
		all: null,
		street: null,
		house: null,
		flat: null,
		front_door: null,
		floor: null,
		intercom: null,
		name: '',
		surname: '',
		patronymic: '',
		telephone: '',
		email: '',
	}
	nameValidShield = ''
	telephoneValidShield = ''
	emailValidShield = ''
	addressValidShield = ''

	constructor(basketStore) {
		this.basketStore = basketStore;
		makeAutoObservable(this)
	}

	setBasketStore(basketStore) {
		this.basketStore = basketStore;
	}

	get type() {
		return this.active?.delivery_type || null
	}

	clear() {
		this.setActive(null)
		this.setPrice(0)
		this.setOfficePvz(null)
		this.express = false
		this.fitting = false
		this.clearCustomerInfo()
		this.setSelectedAddress(null)
		this.basketStore.clearPromoNotificator()
	}

	setAllMethods(array) {
		this.allMethods = array
	}

	setFitting(value){
		this.fitting = value
	}

	setExpress(value){
		this.express = value
	}

	setActive(object, price = null) {
		if (object && object.dop_price) {
			this.setPrice(object.dop_price)
		}
		if(price){
			this.setPrice(price)
		}
		this.active = object
	}

	setPrime(withClear) {
		this.primeDelivery = !withClear ? {
			...this.active,
			dop_price: this.price || this.active?.dop_price
		} : null
	}

	setPreviousActive(object) {
		this.previousActive = object
	}

	setError(string) {
		this.error = string
	}

	setHasError(err) {
		this.hasError = err
	}

	setPrice(number) {
		this.price = number
		this.basketStore.setUpdate();
	}

	setTerms(object) {
		this.terms = object
	}

	setOfficePvz(object) {
		console.log(object)
		this.officePvz = object
	}

	setCityInfo(object) {
		this.searchAddress = null;
		this.editDataDelivery = null;
		this.selectedAddress = null;

		this.cityInfo = object
	}

	setCityInfoError(string) {
		this.cityInfoError = string
	}

	setCustomerInfo(object) {
		this.customerInfo = object
	}

	clearCustomerInfo() {
		this.customerInfo = {
			all: null,
			street: null,
			house: null,
			flat: null,
			front_door: null,
			floor: null,
			intercom: null,
			subscribeNews: false,
			agreePrivacy: false,
			name: '',
			surname: '',
			patronymic: '',
			telephone: '',
			email: '',
		}
	}

	setNameValidShield(string) {
		this.nameValidShield = string
	}

	setTelephoneValidShield(string) {
		this.telephoneValidShield = string
	}

	setEmailValidShield(string) {
		this.emailValidShield = string
	}

	setAddressValidShield(string) {
		this.addressValidShield = string
	}

	setSelectedAddress(item) {
		this.selectedAddress = item;
	}

	setSearchAddress(value) {
		this.searchAddress = value
	}

	setEditDataPickup(data) {
		this.editDataPickup = data
	}

	setEditDataDelivery(data) {
		this.editDataDelivery = data
	}

	clearEditDataDelivery() {
		this.editDataDelivery = null
	}
}
